


























































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import ModifiedDataHandler from '@/mixins/ModifiedDataHandler'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import ListItem from '@/components/list/ListItem.vue'
import ItemForm from '@/pages/issue/components/ItemForm.vue'
import {initItem, ItemFormData} from '@/pages/issue/constants/init-item'
import {calcTaxationTaxFromSupplyCost} from '@/pages/issue/utils/calculate-amounts'
import {cloneDeep, sumBy} from 'lodash'
import toCurrency from '@/filters/to-currency'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'

const issue = namespace('issue')
const gtm = namespace('gtm')

@Component({
  components: {
    ListItem, ItemForm,
    TitleAndMessage, MainLayout, HeaderLayout, FooterLayout, FooterButton
  },
  methods: {toCurrency},
})
export default class IssueSetItems extends Mixins(Translation, ModifiedDataHandler, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: string
  @Prop({default: false, type: Boolean}) isConfirm: boolean

  @issue.State('writeDate') writeDate: string
  @issue.State('items') stateItems: ItemFormData[]
  @issue.Getter('gtmCommonInfo') gtmCommonInfo: object
  @issue.Mutation('update') update: (payload: any) => void
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  @Ref('itemForm') readonly itemForm!: any

  items: ItemFormData[] = [
    cloneDeep(initItem),
  ]

  get totalAmount(): number {
    return sumBy(this.items, 'totalAmount')
  }

  get buttonText(): string {
    const {ts, totalAmount} = this
    const totalAmountText = totalAmount ? `${ts('total')} ${toCurrency(totalAmount)}${ts('currency')}` : ''
    return [totalAmountText, `${ts('issue')}하기`].join(' ')
  }

  get isSelectedTaxFree(): boolean {
    return this.items.some((item) => item.taxFree)
  }

  get isTaxFreeError(): boolean {
    return this.isSelectedTaxFree && this.items.some((item) => !item.taxFree)
  }

  get isMultiData(): boolean {
    return this.items.length > 1
  }

  @Watch('items', {deep: true})
  __items(value) {
    this.modifiedData = this.diffData(this.originalData, value)
  }

  created() {
    if(this.stateItems.length) {
      this.items = cloneDeep(this.stateItems)
    }
    this.setOriginalData(this.items)
  }

  mounted() {
    if(this.isConfirm) {
      this.$nextTick(() => {
        Promise.all(this.itemForm?.map((item) => item?.formRef?.validate())).catch((e) => e)
      })
    }
  }

  beforeDestroy() {
    if(this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'confirm_items',
        eventProperties: {
          modified: this.isModifiedData,
          ...this.gtmCommonInfo,
        }
      })
    }
  }

  onAddItem() {
    this.items.push({
      ...cloneDeep(initItem),
      taxFree: this.isSelectedTaxFree,
    })
  }

  onRemoveItem(index) {
    this.items.splice(index, 1)
  }

  onClickBackward() {
    if(this.isModifiedData) {
      const {message, options} = this.confirmMessageOptions
      this.$confirm(message, options)
        .then(() => {
          this.items = this.originalData
        })
        .then(() => {
          this.$emit('action', 'back')
        })
        .catch((e) => e)
    } else {
      this.$emit('action', 'back')
    }
  }

  onClickDone() {
    Promise.all(this.itemForm?.map((item) => item?.formRef?.validate()))
      .then(() => {
        this.update({items: this.items})
        this.$emit('action', 'ok')
        if(!this.isConfirm) {
          this.logEventWithGroups({
            eventType: 'input_items',
            eventProperties: {
              ...this.gtmCommonInfo,
              'tax_amount': sumBy(this.items, 'tax'),
              'tax_modified': this.items.some((item) => item.tax !== calcTaxationTaxFromSupplyCost(item.supplyCost)),
              'detail_updated': this.items.some((item) => Boolean(item.spec || item.remark || item.purchaseDate)),
            }
          })
        }

      })
      .catch((e) => e)
  }

  setItemsTaxFree(value) {
    this.items.forEach((item) => {
      item.taxFree = value
      item.tax = value ? 0 : calcTaxationTaxFromSupplyCost(item.supplyCost)
    })
  }
}
